import { EventCreateTabsPage } from '../event/create/event-create-tabs/event-create-tabs';
import { App, NavController, Events } from 'ionic-angular';
import { SessionProvider } from '../../providers/session/session';
import { Component } from '@angular/core';
import { LoginPage } from '../login/login/login';
import { TabsPage } from '../tabs/tabs';
import { NewTouMainPage } from '../apps/gamer/pages/new-tou/new-tou-main';
import { TournamentService } from '../apps/gamer/services/tournament.service';
import { AppDetectorProvider } from '../../providers/detector/detector';

@Component({
  templateUrl: 'events-launcher.html',
  selector: 'events-launcher'
})
export class EventsLauncherPage {
  $loginSub = null;
  $logoutSub = null;
  $planSub = null;
  openNewPage: boolean = false;

  constructor(
    public sessionService: SessionProvider,
    private app: App,
    private appDetector: AppDetectorProvider,
    private gs: TournamentService
    ) { }

  onLogin() {
    (this.app.getRootNav() as NavController).push(LoginPage);
  }

  onNewTournament(){
    if(!this.sessionService.isLoged){
       this.onLogin();
       this.openNewPage = true;
    }else{
      (this.app.getRootNav() as NavController).push(this.getNewEventPage());
    }
  }

  

  getNewEventPage(){
    if(this.appDetector.isLeaderBoardApp()){
      return EventCreateTabsPage;
    }else if(this.appDetector.isTournamentApp()){
      return NewTouMainPage;
    }
  }

  ngOnInit() {
    if (!this.$loginSub) {
      this.$loginSub = this.sessionService.onRequestLoggedIn().subscribe(() => {
        (this.app.getRootNav() as NavController).setRoot(TabsPage).then(() => {
          if (this.openNewPage) {
            (this.app.getRootNav() as NavController).push(this.getNewEventPage());
          }
        })
      });
    }

    if (!this.$planSub) {
      this.$planSub = this.gs.$planListChangeSub.subscribe(() => {
        (this.app.getRootNav() as NavController).setRoot(TabsPage);
      });
    }
  }
  
  ngOnDestroy(){
    if(this.$loginSub) {
      this.$loginSub.unsubscribe();
      this.$loginSub = null;
    }
    if(this.$planSub){
      this.$planSub.unsubscribe();
      this.$planSub = null;
    }
  }


}



// WEBPACK FOOTER //
// /src/pages/events-launcher/events-launcher.ts